/* 'use strict';

var novicell = novicell || {};

novicell.languagePicker = novicell.languagePicker || new function () {

    const languagePicker = document.getElementById('.js-language-picker');
    const activeClass = 'language-picker__button--active';
    const listActiveClass = 'language-picker-list--active';

    this.init = function () {
        for (let i = 0; i < btns.length; i++) {
            const btn = btns[i];

            btn.addEventListener('click', toggleLanguagePicker);
        }
    };

    function toggleLanguagePicker(event) {
        event.preventDefault();
        const targetElm = event.target;

        if (novicell.helper.hasClass(targetElm, activeClass)) {
            closeLanguagePicker(targetElm);
        } else {
            openLanguagePicker(targetElm);
        }
    }

    function openLanguagePicker(elm) {
        console.log('open');

        elm.classList.add(activeClass);
        elm.nextElementSibling.classList.add(listActiveClass);
        document.addEventListener('click', handleClick, true);
    }

    function closeLanguagePicker(elm) {
        console.log('close');

        elm.classList.remove(activeClass);
        elm.nextElementSibling.classList.remove(listActiveClass);
        document.removeEventListener('click', handleClick, true);
    }

    function handleClick(e) {
        var targetElement = e.target;
        console.log(targetElement);

        // This is a click outside.
        closeLanguagePicker(targetElement);
    }
}();
 */




'use strict';

var novicell = novicell || {};

novicell.languagePicker = novicell.languagePicker || new function () {

    const languagePicker = document.getElementById('js-language-picker');
    const languagePickerList = document.getElementById('js-language-picker-list');
    const activeClass = 'language-picker--active';

    this.init = function () {
        var trigger = document.getElementById('js-language-picker-trigger');

        if (!trigger) {
            return;
        }
        // Open language picker
        trigger.addEventListener('click', clickTrigger);
    };

    function clickTrigger(e) {
        e.preventDefault();

        closeOverlayHandler();
        languagePicker.classList.add(activeClass);
    }

    function closeOverlayHandler() {
        document.addEventListener('keydown', handleEsc, true);
        document.addEventListener('click', handleClick, true);
    }

    function closeLanguagePicker() {
        languagePicker.classList.remove(activeClass);
        document.removeEventListener('keydown', handleEsc, true);
        document.removeEventListener('click', handleClick, true);
    }

    function handleEsc(e) {
        if (e.keyCode === 27) {
            closeLanguagePicker();
        }
    }

    function handleClick(e) {
        var targetElement = e.target;
        do {
            if (targetElement == languagePickerList) {
                // This is a click inside. Do nothing, just return.
                return;
            }
            targetElement = targetElement.parentNode;
        } while (targetElement);

        // This is a click outside.
        closeLanguagePicker();
    }
}();
